import {ModalWrapper} from "reoverlay";
import React from "react";
import ListItem from "../../ListItem";
import Button from "../../newComponents/button/Button";
import { PiNotePencil, PiTrash} from "react-icons/pi";
const BillInfoModal=({billInfo,onEdit,onInquiry,onDelete})=>{

    return <ModalWrapper animation="slideUp" contentContainerClassName="w-11/12 md:w-5/12 fixed w-full bottom-0 bg-gray-50 lg:w-4/12  rounded-t-2xl" >
                <div className="">
                    <div className="w-full px-5 py-3  flex flex-col justify-center items-center  mb-2 border-b"><h1 className="font-black text-gray-800">جزییات قبض</h1></div>
                    <div className="grid grid cols-1">
                        <ListItem value={billInfo.alias} title={'نام مستعار'}/>
                        <ListItem value={billInfo.bill_main_param} title={'شناسه قبض'}/>
                    </div>
                    <div className="grid px-2 py-3  border-t   grid-cols-6 gap-2">
                        <Button rounded="rounded"  className="col-span-1 flex items-center justify-center"  onClick={onEdit} theme="light" ><PiNotePencil className="text-lg"/></Button>
                        <Button rounded="rounded"  className="col-span-1 flex items-center justify-center"  onClick={onDelete} theme="danger" ><PiTrash className="text-lg"/></Button>
                        <Button rounded="rounded" className="col-span-4" onClick={onInquiry} theme="primary">استعلام</Button>

                    </div>
        </div>
          </ModalWrapper>
}
export default BillInfoModal;